import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { SessionService }              from '../sessions/session.service';
import { UKPostcodeService }           from './uk-postcode.service';
import { UKPostcodeSettingsComponent } from './uk-postcode.settings.component';

export const UKPostcodeStates : Array<NgHybridStateDeclaration> = [
  {
    component: UKPostcodeSettingsComponent,
    name     : 'app.uk-postcode',
    resolve  : [
      {
        deps     : [ UKPostcodeService ],
        resolveFn: ( ukPostcodeService : UKPostcodeService ) : Promise<number> => ukPostcodeService.getAvailableRequests(),
        token    : 'availableRequests'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<any> => sessionService.refresh(),
        token    : 'session'
      }
    ],
    url: '/uk-postcode'
  }
];
